import { type ComponentType, useCallback } from 'react';
import cn from 'classnames';
import { type ColumnCellTemplateProps } from '@adv-frontend/grid';
import { getCellDataTestId } from './getCellDataTestId';
import { type AdditionalCellProps, type BaseRowData, type ExtendCellTemplateProps } from './types';
import styles from './ExtendGridCell.module.css';

export function renderExtendGridCell<RowData extends BaseRowData>(
    Cell: ComponentType<
        ExtendCellTemplateProps<RowData> & {
            hasMainColumnActions?: boolean;
        }
    >,
    additionalProps: AdditionalCellProps<RowData> = {}
) {
    const { onClickRow, hasMainColumnActions } = additionalProps;

    return function RenderCellWithDataTestIdHoc(props: ColumnCellTemplateProps<RowData>) {
        const handleClick = useCallback(() => onClickRow?.(props.data), [props.data]);

        return (
            <Cell
                data-testid={getCellDataTestId(props)}
                hasMainColumnActions={hasMainColumnActions}
                {...props}
                onClick={handleClick}
                className={cn({
                    [styles.clickable]: Boolean(onClickRow),
                })}
            />
        );
    };
}
